export enum EMarginAllocationSteps {
  DAY_TRADE_LIMITS,
  BALANCE,
  DRAWDOWN,
  REVIEW,
  TRADER_SHIELD,
  ERROR
}
